"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- qa ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

// $(".megaMenu__btn").on("click", function() {
//   $(this).next().slideToggle();
//   $(this).toggleClass("is-active");
// });

// document.addEventListener('DOMContentLoaded', function() {
//     const menuBtn = document.querySelector('.menu__btn');
//     const menu = document.querySelector('.menu');

//     menuBtn.addEventListener('mouseenter', function() {
//         menuBtn.classList.add('is-active');
//         menu.classList.add('is-active');
//     });

//     menuBtn.addEventListener('mouseleave', function() {
//         menuBtn.classList.remove('is-active');
//         menu.classList.remove('is-active');
//     });

//     menu.addEventListener('mouseenter', function() {
//         menuBtn.classList.add('is-active');
//         menu.classList.add('is-active');
//     });

//     menu.addEventListener('mouseleave', function() {
//         menuBtn.classList.remove('is-active');
//         menu.classList.remove('is-active');
//     });
// });



// 共通のスライダー設定関数（エラーログのみ）
function initSplide(selector, options) {
  const element = document.querySelector(selector);
  if (element) {
    const track = element.querySelector('.splide__track');
    const list = element.querySelector('.splide__list');

    if (track && list) {
      try {
        new Splide(element, options).mount();
      } catch (error) {
        console.error(`${selector} スライダーの初期化に失敗:`, error);
      }
    }
  }
}

// DOMが読み込まれたときに実行
document.addEventListener('DOMContentLoaded', function () {
  // FVスライダーの設定
  initSplide('.fv__slider', {
    autoplay: true,
    type: 'loop',
    pauseOnHover: false,
    pauseOnFocus: false,
    pagination: false,
    interval: 5000,
    speed: 1000,
    padding: '2.5%',
    gap: 20,
    arrows: false,
    classes: {
      pagination: 'splide__pagination your-class-pagination',
      page: 'splide__pagination__page your-class-page',
    },
    breakpoints: {
      767: {
        padding: '0',
      },
    },
  });

  // // topCase__sliderの設定
  // initSplide('.topCase__slider', {
  //   focus: 'center',
  //   autoplay: true,
  //   arrows: false,
  //   type: 'loop',
  //   pauseOnHover: false,
  //   pauseOnFocus: false,
  //   interval: 4000,
  //   speed: 1000,
  //   padding: '8%',
  //   gap: 25,
  //   pagination: true,
  //   perPage: 3,
  //   classes: {
  //     pagination: 'splide__pagination topCase__pagination',
  //     page: 'splide__pagination__page topCase__page',
  //   },
  //   breakpoints: {
  //     767: {
  //       padding: '10%',
  //       gap: 20,
  //       perPage: 1,
  //     },
  //   },
  // });

  // topNews__sliderの修正版設定
  // topNews__sliderの設定（より滑らかなスライド）
  initSplide('.topNews__slider', {
    type: 'loop',
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 4000, // 少し長めに設定
    speed: 800, // 少し早めのアニメーション
    gap: 10,
    pagination: false,
    perPage: 3,
    perMove: 1, // 1記事ずつ移動
    easing: 'ease-out', // イージング効果を追加
    padding: {
      left: 0,
      right: '15%',
    },
    breakpoints: {
      767: {
        perPage: 1,
        perMove: 1,
        gap: 5,
        padding: 0,
        // interval: 3000, // モバイルでは少し早めに
      },
    },
  });
});




/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};

// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}



/* ----- 下部CTA ----- */
document.addEventListener('DOMContentLoaded', () => {
  const fixedLink = document.querySelector('.banner');

  // 最初は非表示
  fixedLink.style.opacity = '0';
  fixedLink.style.visibility = 'hidden';

  document.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const showAfterScroll = 300; // 300pxスクロールしたら表示

    if (scrollTop + windowHeight >= documentHeight) {
      // ページの一番下に到達したら非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    } else if (scrollTop > showAfterScroll) {
      // 300px以上スクロールしたら表示
      fixedLink.style.opacity = '1';
      fixedLink.style.visibility = 'visible';
    } else {
      // それ以外は非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    }
  });
});



/* タブ切り替えメニュー */
document.addEventListener('DOMContentLoaded', function(){

  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName('js-tab');
  for(let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', tabSwitch, false);
  }

  // タブをクリックすると実行する関数
  function tabSwitch(){
    // タブのclassの値を変更
    document.getElementsByClassName('is-active')[0].classList.remove('is-active');
    this.classList.add('is-active');
    // コンテンツのclassの値を変更
    document.getElementsByClassName('is-show')[0].classList.remove('is-show');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('js-panel')[index].classList.add('is-show');
  };
}, false);



/* ----- スライダー ----- */
  $('.fv-slider').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    speed: 1000,
    pauseOnHover: false,
    dots: false,
    arrows: false,
    centerMode: true,
    asNavFor: '.navi-slider'
  });

  $('.fv-sub-slider').slick({
    slidesToShow: 3,
    asNavFor: '.fv-slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '0px',
  });

  $('.fv-circle').slick({
    slidesToShow: 3,
    asNavFor: '.fv-slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '0px',
    vertical: true,
  });

  $('.fv-sub-slider').find('.slick-slide').click(function() {
    let slickIndex = $(this).data('slick-index');
    $('.fv-circle').find('.slick-slide').removeClass('slick-current');
    $('.fv-circle').find('.slick-slide[data-slick-index="' + slickIndex + '"]').addClass('slick-current');
  })
